SET_USER_ACCOUNT_SUBSCRIPTION_MANAGE_TYPE